import { debounce, querySelectorAll } from '../helpers'

function isTabFullWidth(el: Element) {
  if (el.parentElement) {
    return (
      el.getBoundingClientRect().width ===
      el.parentElement.getBoundingClientRect().width
    )
  }
}

function isTabSelected(el: Element) {
  return (el.previousElementSibling as HTMLInputElement).checked
}

function selectTab(el: Element) {
  const input = el.previousElementSibling as HTMLInputElement
  if (input) {
    input.checked = true
  }
}

function deselectTab(el: Element) {
  const input = el.previousElementSibling as HTMLInputElement
  if (input) {
    input.checked = false
  }
}

function showFirstTab(tabview: HTMLDivElement) {
  const tabs = querySelectorAll<HTMLLabelElement>('.tabview_tab', tabview)
  const tabviewIncludesHomeLink = querySelectorAll('.tabview_tab').find(tab =>
    tab.classList.contains('tabview_tab--home')
  )

  if (tabviewIncludesHomeLink) {
    let activatedTab = false
    tabs.forEach(tab => {
      if (!activatedTab && !tab.classList.contains('tabview_tab--home')) {
        activatedTab = true
        selectTab(tab)
      }
    })
  } else {
    selectTab(tabs[0])
  }
}

function activateHomeTab(tabview: HTMLDivElement) {
  const homeTab = tabview.querySelector('.tabview_tab--home')
  if (homeTab) {
    homeTab.addEventListener('click', e => {
      e.preventDefault()
      window.location.href = '/'
    })
  }
}

export function initializeAccordionTabview(selector: string) {
  const tabviews = querySelectorAll<HTMLDivElement>(selector)
  tabviews.forEach((tabview: HTMLDivElement) => {
    const tabs: HTMLLabelElement[] = querySelectorAll('.tabview_tab', tabview)

    if (tabs.length) {
      activateHomeTab(tabview)

      showFirstTab(tabview)

      window.addEventListener(
        'resize',
        debounce(() => {
          showFirstTab(tabview)
        }, 50)
      )

      tabs.forEach((tab: Element) => {
        tab.addEventListener('click', (e: Event) => {
          if (isTabFullWidth(tab)) {
            if (isTabSelected(tab)) {
              e.preventDefault()
              deselectTab(tab)
            } else {
              setTimeout(() => {
                window.scrollTo({
                  behavior: 'smooth',
                  left: 0,
                  top: tab.getBoundingClientRect().top + window.scrollY,
                })
              }, 50)
            }
          }
        })
      })
    }
  })
}
